module.exports = __webpack_public_path__ + "/images/ico-login-rounded-google.28c4ef8.svg";